interface ICardProps {
  children: JSX.Element;
  className?: string;
  onClick?: () => void
}

const Card = ({children, onClick,className}: ICardProps) => {
  return (
      <div className={`bg-white rounded-md shadow-md ${className}`} onClick ={onClick} >
          {children}
      </div>
  );
};

export default Card;
